'use strict';

import './index.scss';
import app from '../ngmodule';
import { v4 as uuidv4 } from 'uuid';
import angular from 'angular';
import { ControllerBase } from '../control-base';
import { StringNullableChain } from 'lodash';

export class IconController extends ControllerBase {
    public icon: string;


    static $inject = ['$element', '$timeout'];
    constructor(protected $element: ng.IRootElementService, protected $timeout: ng.ITimeoutService) {
        super();

        this.icon = '';
    }

    protected valuesFromHtml() : void {
        if (this.icon == undefined || this.icon.toString() == "0") {
            this.icon = this.valueFromHtml("icon", '', this.$element);
        }
    }

    $onInit(): void {
        this.valuesFromHtml();
        this.createKendoIcon();
    }

    $onChanges(changes: angular.IOnChangesObject): void {
        if(changes.icon && changes.icon.currentValue != undefined && changes.icon.currentValue != 0) {
            this.icon = changes.icon.currentValue;
            this.createKendoIcon();
        }
    }

    protected createKendoIcon() {
        let options: kendo.ui.SvgIconOptions = {
            icon: this.icon
        };

        kendo.ui.icon(this.$element.find('.vm-icon'), options);
    }
}

app.component('vmIcon', {
    template: require('./template.html').default,
    bindings: {
        icon: '<'
    },
    controller:  IconController
});